export default __webpack_public_path__ + "static/media/scrollRight5.0d948757.jpg";